import { Controller } from '@hotwired/stimulus';

import RailsApi from '../models/rails-api';

type PaginationResponse = {
  containerHTML: string;
  paginatorHTML: string;
};

type PaginatorUpdateEvent = {
  detail: {
    paginatorHTML: string;
  };
};

function isFormElement(element: EventTarget | null): element is HTMLFormElement {
  if (element instanceof HTMLElement) {
    return element.matches('form');
  }
  return false;
}

export default class extends Controller {
  static targets = ['container', 'paginator'];

  abortController?: AbortController;

  containerTarget: HTMLElement;

  paginatorTarget: HTMLElement;

  onUpdatePaginatorHTML(event: PaginatorUpdateEvent) {
    this.paginatorTarget.innerHTML = event.detail.paginatorHTML;
    this.abortController?.abort();
  }

  async paginate(event: Event) {
    event.preventDefault();
    let form = event.target;
    if (event.target instanceof HTMLInputElement) {
      form = event.target.form;
    }

    try {
      if (isFormElement(form)) {
        this.abortController = new AbortController();

        const response = await RailsApi.fetch(form.action, { signal: this.abortController.signal });
        const { containerHTML, paginatorHTML } = (await response.json()) as PaginationResponse;

        if (containerHTML) {
          this.containerTarget.insertAdjacentHTML('beforeend', containerHTML);
        }
        this.paginatorTarget.innerHTML = paginatorHTML;
      } else {
        throw new Error('Controller action `paginate` must be triggered by a form submission');
      }
    } catch (error) {
      if (error instanceof DOMException && error.code === error.ABORT_ERR) {
        return;
      }

      throw error;
    } finally {
      delete this.abortController;
    }
  }
}
